export default "__VITE_ASSET__Dy$hFrRj__"